import { useInfiniteQuery } from '@tanstack/react-query';

import MerchandisingCollectionsService, {
  QueryFilterDto,
} from '@/services/MerchandisingCollectionsService';

export const MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY = [
  'merchandisingCollectionSliceProducts',
];

export function useGetMerchandisingCollectionSliceProducts(
  collectionId: number,
  sliceId: number,
  queryFilter?: QueryFilterDto,
) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [
        ...MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY,
        collectionId,
        sliceId,
      ],
      initialPageParam: queryFilter?.page ?? 1,
      queryFn: ({ pageParam }) =>
        MerchandisingCollectionsService.findSliceProducts(
          collectionId,
          sliceId,
          {
            page: pageParam,
            limit: queryFilter?.limit ?? 10,
          },
        ),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const { currentPage, totalPages } = lastPage;

        if (currentPage === totalPages || totalPages === 0) {
          return null;
        }

        return lastPageParam + 1;
      },
    });

  const sliceProducts = data?.pages.flatMap((page) => page?.items);
  const totalItems = data?.pages
    .flatMap((page) => page.totalItems)
    .reduce((acc, total) => acc + total, 0);

  return {
    sliceProducts: sliceProducts ?? [],
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    totalItems: totalItems ?? 0,
  };
}
